import React, { Component } from 'react';

class NotFoundPage extends Component{

  componentWillMount=()=>{
    this.props.history.push({
      pathname:"/",
  })
  }

  render(){
    return(
      <div>
      </div>
    )
  }
}

export default NotFoundPage;